const API_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;

// Fire-and-forget logging of a Telegram join-CTA click. Never blocks navigation.
export const trackTelegramClick = (source = 'icon') => {
  try {
    const body = JSON.stringify({ source });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API_URL}/api/telegram/click`, new Blob([body], { type: 'application/json' }));
    } else {
      fetch(`${API_URL}/api/telegram/click`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch (e) {
    /* ignore */
  }
};
